import { useTranslation } from 'react-i18next';
import './PageSpinner.css';

/**
 * Spinner de carga centrado en el área de contenido. Pensado para mostrarse
 * mientras una pestaña (Cargas, Estadísticas, Avisos…) está cargando datos por
 * primera vez y aún no hay nada que pintar.
 *
 * Detalle clave de UX: el spinner tiene un retardo de aparición (~150 ms) vía
 * CSS. Si los datos llegan al instante (típico cuando vienen de la caché de
 * IndexedDB / Service Worker) el componente se desmonta antes de hacerse
 * visible, evitando un parpadeo molesto. Solo cuando la carga tarda de verdad
 * aparece, con un fade-in suave.
 */
export function PageSpinner({ label }: { label?: string }) {
  const { t } = useTranslation();
  // Sin label explícito, usa el texto localizado (idioma activo de la app).
  const text = label ?? t('common.loading');
  return (
    <div className="page-spinner" role="status" aria-live="polite">
      <div className="page-spinner__ring" aria-hidden="true" />
      {text && <span className="page-spinner__label">{text}</span>}
    </div>
  );
}
